export default "__VITE_ASSET__Le_9_cyD__"